import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../instance";
import axios from "axios";

// const url = process.env.REACT_APP_API_BASE_URL;

const initialState = {
  saving: false,
  singleloggedInUser: {},
  sentSmsData: [],
  loadingSms: false,
  sentSmsCount: 0,
  senderIdData: [],
  senderIdCount: 0,
  loadingId: false,
  templatesData: [],
  templateCount: 0,
  loading: false,
};

// export const save = createAsyncThunk('saveSlice/save', async (data) => {
// 	let saveUrl = data.url;
// 	delete data.url;
// 	const res = await axiosInstance
// 		.post(`${url}${saveUrl}`, data)
// 		.then((res) => res.data);
// 	return res;
// });

export const saveForget = createAsyncThunk(
  "saveSlice/save",
  async (data, { rejectWithValue }) => {
    let saveUrl = data.url;
    delete data.url;
    try {
      const response = await axiosInstance.post(`/${saveUrl}`, data);
      if (!response.data.success) {
        return rejectWithValue(response.data);
      }
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const save = createAsyncThunk(
  "saveSlice/save/ordinary",
  async (data, { rejectWithValue }) => {
    let saveUrl = data.url;
    delete data.url;
    await new Promise((resolve) => setTimeout(resolve, 0));
    try {
      const response = await axiosInstance.post(`/${saveUrl}`, data);
      if (!response.data.success) {
        return rejectWithValue(response.data);
      }
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const saveArray = createAsyncThunk(
  "saveSlice/saveArray/ordinary",
  async (data, { rejectWithValue }) => {
    let saveUrl = data.url;
    delete data.url;
    await new Promise((resolve) => setTimeout(resolve, 0));
    const payloadToSend = Array.isArray(data.data) ? data.data : data;

    try {
      const response = await axiosInstance.post(`/${saveUrl}`, payloadToSend);
      if (!response.data.success) {
        return rejectWithValue(response.data);
      }
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const saveNoToken = createAsyncThunk(
  "saveSlice/save/notoken",
  async (data, { rejectWithValue }) => {
    let saveUrl = data.url;
    delete data.url;
    try {
      const response = await axios.post(`/${saveUrl}`, data);
      if (!response.data.success) {
        return rejectWithValue(response.data);
      }
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const saveFile = createAsyncThunk("saveSlice/saveFile", async (data) => {
  const res = await axiosInstance
    .post(`/v1/api/att/upload`, data, {
      headers: {
        "content-type": "multipart/form-data",
      },
    })
    .then((res) => res.data);
  return res;
});

export const saveExcel = createAsyncThunk(
  "saveSlice/saveExcel",
  async (data) => {
    const res = await axiosInstance
      .post(`/api/v2/member/upload`, data, {
        headers: {
          "content-type": "multipart/form-data",
        },
      })
      .then((res) => res.data);
    return res;
  }
);

export const saveSmsCsv = createAsyncThunk(
  "saveSlice/saveSmsCsv",
  async (data) => {
    const res = await axiosInstance
      .post(`/api/v2/sms/upload-csv`, data, {
        headers: {
          "content-type": "multipart/form-data",
        },
      })
      .then((res) => res.data);
    return res;
  }
);

export const fetchSavedSms = createAsyncThunk(
  "saveSlice/fetch/saved/sms",
  async (data, { rejectWithValue }) => {
    let saveUrl = data.url;
    delete data.url;
    try {
      const response = await axiosInstance.post(`/${saveUrl}`, data);
      if (!response.data.success) {
        return rejectWithValue(response.data);
      }
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const downloadExcel = createAsyncThunk(
  "sms/downloadExcel",
  async (data, { rejectWithValue }) => {
    let saveUrl = data.url;
    delete data.url;
    try {
      const response = await axiosInstance.post(`/${saveUrl}`, data, {
        responseType: "blob",
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const fetchSenderIds = createAsyncThunk(
  "saveSlice/fetch/fetchSenderIds",
  async (data, { rejectWithValue }) => {
    let saveUrl = data.url;
    delete data.url;
    try {
      const response = await axiosInstance.post(`/${saveUrl}`, data);
      if (!response.data.success) {
        return rejectWithValue(response.data);
      }
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const fetchTemplates = createAsyncThunk(
  "saveSlice/fetch/fetchTemplates",
  async (data, { rejectWithValue }) => {
    let saveUrl = data.url;
    delete data.url;
    try {
      const response = await axiosInstance.post(`/${saveUrl}`, data);
      if (!response.data.success) {
        return rejectWithValue(response.data);
      }
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const saveFileUpload = createAsyncThunk(
  "saveSlice/save/saveFileUpload",
  async ({ url, formData }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(url, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      if (!response.data.success) {
        return rejectWithValue(response.data);
      }

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data);
    }
  }
);

//   export const saveExcelCasual = createAsyncThunk('saveSlice/saveExcelCasual', async (data) => {
// 	const res = await axiosInstance
// 		.post(`${url}/api/v2/member/upload`, data, {
// 			headers: {
// 				'content-type': 'multipart/form-data'
// 			}
// 		})
// 		.then((res) => res.data);
// 	return res;
// });
// localhost:8080/NDOVUHR_BACKEND/hr/uploadAttendance.action

export const saveSlice = createSlice({
  name: "save",
  initialState,
  reducers: {
    cleanSingleloggedInUser: (state, action) => {
      state.singleloggedInUser = initialState.singleloggedInUser;
    },
    clearSaveObj: () => {
      return { ...initialState };
    },
  },
  extraReducers: (builder) => {
    builder

      .addCase(saveForget.pending, (state) => {
        state.saving = true;
      })
      .addCase(saveForget.fulfilled, (state, action) => {
        state.saving = false;
        state.singleloggedInUser = action.payload?.data?.result;
      })
      .addCase(saveForget.rejected, (state) => {
        state.saving = false;
      })

      .addCase(save.pending, (state) => {
        state.saving = true;
      })
      .addCase(save.fulfilled, (state, action) => {
        state.saving = false;
      })
      .addCase(save.rejected, (state) => {
        state.saving = false;
      })

      .addCase(saveArray.pending, (state) => {
        state.saving = true;
      })
      .addCase(saveArray.fulfilled, (state, action) => {
        state.saving = false;
      })
      .addCase(saveArray.rejected, (state) => {
        state.saving = false;
      })

      .addCase(saveNoToken.pending, (state) => {
        state.saving = true;
      })
      .addCase(saveNoToken.fulfilled, (state, action) => {
        state.saving = false;
      })
      .addCase(saveNoToken.rejected, (state) => {
        state.saving = false;
      })

      .addCase(saveFile.pending, (state) => {
        state.saving = true;
      })
      .addCase(saveFile.fulfilled, (state, action) => {
        state.saving = false;
      })
      .addCase(saveFile.rejected, (state) => {
        state.saving = false;
      })

      .addCase(saveExcel.pending, (state) => {
        state.saving = true;
      })
      .addCase(saveExcel.fulfilled, (state, action) => {
        state.saving = false;
      })
      .addCase(saveExcel.rejected, (state) => {
        state.saving = false;
      })

      .addCase(saveSmsCsv.pending, (state) => {
        state.saving = true;
      })
      .addCase(saveSmsCsv.fulfilled, (state, action) => {
        state.saving = false;
      })
      .addCase(saveSmsCsv.rejected, (state) => {
        state.saving = false;
      })

      .addCase(fetchSavedSms.pending, (state) => {
        state.loadingSms = true;
      })
      .addCase(fetchSavedSms.fulfilled, (state, action) => {
        state.loadingSms = false;
        state.sentSmsData = action.payload?.data?.result;
        state.sentSmsCount = action.payload?.total;
      })
      .addCase(fetchSavedSms.rejected, (state) => {
        state.loadingSms = false;
        state.sentSmsData = [];
        state.sentSmsCount = 0;
      })

      .addCase(downloadExcel.pending, (state) => {
        state.saving = true;
      })
      .addCase(downloadExcel.fulfilled, (state, action) => {
        state.saving = false;
      })
      .addCase(downloadExcel.rejected, (state) => {
        state.saving = false;
      })

      .addCase(fetchSenderIds.pending, (state) => {
        state.loadingId = true;
      })
      .addCase(fetchSenderIds.fulfilled, (state, action) => {
        state.loadingId = false;
        state.senderIdData = action.payload?.data?.result;
        state.senderIdCount = action.payload?.total;
      })
      .addCase(fetchSenderIds.rejected, (state) => {
        state.loadingId = false;
        state.senderIdData = [];
        state.senderIdCount = 0;
      })

      .addCase(fetchTemplates.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchTemplates.fulfilled, (state, action) => {
        state.loading = false;
        state.templatesData = action.payload?.data?.result;
        state.templateCount = action.payload?.total;
      })
      .addCase(fetchTemplates.rejected, (state) => {
        state.loading = false;
        state.templatesData = [];
        state.templateCount = 0;
      })

      .addCase(saveFileUpload.pending, (state) => {
        state.loading = true;
      })
      .addCase(saveFileUpload.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(saveFileUpload.rejected, (state) => {
        state.loading = false;
      });
  },
});

export default saveSlice.reducer;
export const { cleanSingleloggedInUser, clearSaveObj } = saveSlice.actions;
